import React from 'react';

const MailChimpSignUp = ({
  url = "https://eurodressage.us14.list-manage.com/subscribe?u=ee8a2d6532aa204090d288bf4&id=f510e68c5d", 
  target = "_blank",
  buttonText = "Subscribe to our Newsletter",
  className = "text-center rounded-xl bg-black text-medium p-4 text-white",
  style = {margin:'0 auto'}
}) => {

  const handleClick = () => {
    window.open(url, target);
  };

  return (
    <div className="text-center w-full pt-8">
    <button
      onClick={handleClick}
      className={className}
      style={style}
      type="button"
    >
      {buttonText}
    </button>
    </div>
  );
};

export default MailChimpSignUp;
